(() => {
  const states = new WeakMap();
  const init = root => {
    root.querySelectorAll('[data-gl-card-gallery]').forEach(card => {
      if (states.has(card)) return;
      let images;
      try { images = JSON.parse(card.querySelector('[data-gl-gallery-images]').textContent); } catch { return; }
      if (images.length < 2) return;
      const figure = card.querySelector('[data-product-item-image]');
      if (!figure) return;
      const state = {index:0, sequence:0, blockUntil:0};
      states.set(card,state);
      const count = card.querySelector('[data-gl-gallery-count]');
      const status = card.querySelector('[data-gl-gallery-status]');
      const loaded = new Map();
      const display = index => {
        const token = ++state.sequence;
        state.index = (index + images.length) % images.length;
        const item = images[state.index];
        const commit = image => {
          if (token !== state.sequence || !card.isConnected) return;
          figure.querySelector('.gl-card-gallery-image')?.remove();
          card.classList.toggle('gl-gallery-extra',state.index !== 0);
          if (state.index !== 0) figure.appendChild(image);
          count.textContent = `${state.index + 1} / ${images.length}`;
          status.textContent = status.dataset.label.replace('{current}',state.index + 1).replace('{total}',images.length);
        };
        if (state.index === 0) { commit(null); return; }
        let image = loaded.get(item.src);
        if (image) { commit(image); return; }
        image = new Image();
        image.className = 'gl-card-gallery-image';
        image.alt = item.alt;
        image.draggable = false;
        image.decoding = 'async';
        image.onload = () => { loaded.set(item.src,image); commit(image); };
        image.onerror = () => { if(token === state.sequence) display(0); };
        image.src = item.src;
      };
      card.querySelector('[data-gl-gallery-prev]').addEventListener('click',event => { event.preventDefault();event.stopPropagation();display(state.index - 1); });
      card.querySelector('[data-gl-gallery-next]').addEventListener('click',event => { event.preventDefault();event.stopPropagation();display(state.index + 1); });
      let gesture = null;
      card.addEventListener('touchstart',event => {
        if(event.touches.length !== 1 || event.target.closest('button')) { gesture=null;return; }
        gesture={x:event.touches[0].clientX,y:event.touches[0].clientY,dx:0,locked:false,vertical:false};
      },{passive:true});
      card.addEventListener('touchmove',event => {
        if(!gesture || event.touches.length !== 1) return;
        gesture.dx=event.touches[0].clientX-gesture.x;
        const dy=event.touches[0].clientY-gesture.y;
        if(!gesture.locked && Math.abs(dy)>12 && Math.abs(dy)>Math.abs(gesture.dx)) gesture.vertical=true;
        if(!gesture.vertical && Math.abs(gesture.dx)>12 && Math.abs(gesture.dx)>Math.abs(dy)*1.3) gesture.locked=true;
        if(gesture.locked && event.cancelable) event.preventDefault();
      },{passive:false});
      card.addEventListener('touchend',() => {
        if(gesture?.locked) {
          state.blockUntil=Date.now()+500;
          if(Math.abs(gesture.dx)>=35) display(state.index+(gesture.dx<0?1:-1));
        }
        gesture=null;
      },{passive:true});
      card.addEventListener('touchcancel',()=>{gesture=null;},{passive:true});
      card.querySelectorAll('[data-gl-gallery-prev],[data-gl-gallery-next],[data-gl-gallery-count]').forEach(el=>el.hidden=false);
      display(0);
    });
  };
  window.addEventListener('click',event => {
    const card=event.target.closest?.('[data-gl-card-gallery]');
    if(card && states.get(card)?.blockUntil>Date.now()) {event.preventDefault();event.stopImmediatePropagation();}
  },true);
  init(document);
  new MutationObserver(records=>{
    for(const record of records) for(const node of record.addedNodes) if(node.nodeType===1 && (node.matches('[data-gl-card-gallery]') || node.querySelector('[data-gl-card-gallery]'))) init(node.parentElement || document);
  }).observe(document.documentElement,{childList:true,subtree:true});
})();
